import axios from 'axios';
import { API_BASE } from './config';
import { formatDateForFilename } from './utils/formatDate';

// Reuse config.js's env-driven API_BASE instead of a separately hardcoded
// URL — this file used to hardcode a LAN IP that went stale as soon as the
// machine's network changed, breaking every apiFetch() call at once.
// config.js already has the correct mechanism (REACT_APP_API_HOST via
// .env.local for local dev, production URL by default) and an explicit
// warning against hardcoding localhost directly into a file that also ships
// in production builds.
const BASE_URL = API_BASE;

export async function apiFetch(endpoint, params = {}) {
    const response = await axios.get(`${BASE_URL}/${endpoint}`, { params });
    return response.data;
}

export async function downloadExcel(report, params = {}) {
    const response = await axios.get(`${BASE_URL}/export-excel`, {
        params: { report, ...params },
        responseType: 'blob'
    });
    const url = URL.createObjectURL(response.data);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${report}_${formatDateForFilename()}.xlsx`;
    a.click();
    URL.revokeObjectURL(url);
}
